// extracted by mini-css-extract-plugin
module.exports = {"form_container":"scholarshipRemainderModal_form_container__eq9He","message":"scholarshipRemainderModal_message__1AyAS"};